import type { CountryCode } from 'packages/country-lib';
import type { Currency } from '../common/model/customer';
import type { CurrentUserResponseDto } from './dto';
import type { User } from './model';

export function mapCurrentUserDtoToUser(user: CurrentUserResponseDto): User {
  const account = user.accounts?.[0];
  const countrySplit = (account?.location ?? '').split(',');
  const currency = (account?.currency?.toUpperCase() as Currency) ?? 'EUR';

  return {
    accountId: account.id,
    companyName: account.company,
    country: countrySplit[countrySplit.length - 1] as CountryCode,
    emailAddress: user.user_email ?? '',
    userId: user.user_id,
    firstName: user.user_name,
    lastName: user.user_name,
    currency,
  };
}
